import { Component } from '@angular/core';
import { AuthPageLayoutComponent } from '../../../layout/auth-page-layout/auth-page-layout.component';
import { SigninFormComponent } from '../../../components/auth/login-form/login-form';

@Component({
  selector: 'app-login',
  imports: [
    AuthPageLayoutComponent,
    SigninFormComponent
  ],
  templateUrl: './login.html'
})
export class Login {

}
